import { createContext } from "react";

export const AgencyAccountLinkingContext = createContext({
  linkAccounts: async () => ({ ok: false }),
  linking: false,
  prompt: null,
  completed: false,
  hidden: false,
});
